/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WebApiIntegrationsObjectsAllowCreateInvoiceOption = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type WebApiIntegrationsObjectsAllowCreateInvoiceOption = typeof WebApiIntegrationsObjectsAllowCreateInvoiceOption[keyof typeof WebApiIntegrationsObjectsAllowCreateInvoiceOption];


export function WebApiIntegrationsObjectsAllowCreateInvoiceOptionFromJSON(json: any): WebApiIntegrationsObjectsAllowCreateInvoiceOption {
    return WebApiIntegrationsObjectsAllowCreateInvoiceOptionFromJSONTyped(json, false);
}

export function WebApiIntegrationsObjectsAllowCreateInvoiceOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsObjectsAllowCreateInvoiceOption {
    return json as WebApiIntegrationsObjectsAllowCreateInvoiceOption;
}

export function WebApiIntegrationsObjectsAllowCreateInvoiceOptionToJSON(value?: WebApiIntegrationsObjectsAllowCreateInvoiceOption | null): any {
    return value as any;
}

